import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceSettingsAtlassianIntelligenceFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'displayName' | 'offering'>
  & { enterprise?: Types.Maybe<(
    { __typename: 'Enterprise' }
    & Pick<Types.Enterprise, 'id' | 'name'>
    & { aiPrefs?: Types.Maybe<(
      { __typename: 'Enterprise_AI_Prefs' }
      & Pick<Types.Enterprise_Ai_Prefs, 'atlassianIntelligenceEnabled'>
    )> }
  )>, prefs: (
    { __typename: 'Organization_Prefs' }
    & Pick<Types.Organization_Prefs, 'atlassianIntelligenceEnabled'>
  ) }
);

export const WorkspaceSettingsAtlassianIntelligenceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceSettingsAtlassianIntelligence' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enterprise' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aiPrefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'atlassianIntelligenceEnabled',
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'atlassianIntelligenceEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceSettingsAtlassianIntelligenceFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceSettingsAtlassianIntelligenceFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceSettingsAtlassianIntelligenceFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceSettingsAtlassianIntelligenceFragment>,
    'data'
  > {
  data?: WorkspaceSettingsAtlassianIntelligenceFragment;
}

export const useWorkspaceSettingsAtlassianIntelligenceFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceSettingsAtlassianIntelligenceFragmentOptions): UseWorkspaceSettingsAtlassianIntelligenceFragmentResult => {
  const result =
    Apollo.useFragment<WorkspaceSettingsAtlassianIntelligenceFragment>({
      ...options,
      fragment: WorkspaceSettingsAtlassianIntelligenceFragmentDoc,
      fragmentName: 'WorkspaceSettingsAtlassianIntelligence',
      from: {
        __typename: 'Organization',
        ...from,
      },
    });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as WorkspaceSettingsAtlassianIntelligenceFragment,
  };
};
